import { gql } from "@apollo/client";

export const getPayBillReportMutation = gql`
mutation($filters: JSON!){
  getPayBillReport(filters: $filters) {
    message
    response
  }
}
`;


export const getEmployeePayHourReportMutation = gql`
mutation($filters: JSON!){
  getEmployeePayHourReport(filters: $filters) {
    message
    response
  }
}
`;

export const upsertSystemReportMutation = gql`
mutation($input: SystemReportInput!){
  upsertSystemReport(input: $input) {
    message
    response
  }
}
`;

// Per-user favourite (star) on the reports list.
export const setSystemReportFavouriteMutation = gql`
mutation($reportId: String!, $isFavourite: Boolean!){
  setSystemReportFavourite(reportId: $reportId, isFavourite: $isFavourite) {
    message
    response
  }
}
`;

// Feeds the "Last Run" column on the reports list — recorded per tenant when a report is run.
export const recordSystemReportRunMutation = gql`
mutation($reportId: String!){
  recordSystemReportRun(reportId: $reportId) {
    message
    response
  }
}
`;


export const siteScheduleReportMutation = gql`
  mutation($filters: JSON!){
    getSiteScheduleReport(filters: $filters) {
      message
      response
    }
  }
`;


export const getKeyHoldingChargeMutation = gql`
  mutation($filters: JSON!){
    getKeyHoldingCharge(filters: $filters) {
      message
      response
      unconfiguredCount
      unconfiguredSites
    }
  }
`;


export const getKeyHoldingPayMutation = gql`
  mutation($filters: JSON!){
    getKeyHoldingPay(filters: $filters) {
      message
      response
    }
  }
`;


export const getMobileServicesScheduleReportMutation = gql`
  mutation($filters: JSON!){
    getMobileServicesScheduleReport(filters: $filters) {
      message
      response
    }
  }
`;


export const getMobileServicesPayReporttMutation = gql`
  mutation($filters: JSON!){
    getMobileServicesPayReport(filters: $filters) {
      message
      response
    }
  }
`;

export const getHoursPayBillAnalysisReportMutation = gql`
  mutation($filters: JSON!){
    getHoursPayBillAnalysisReport(filters: $filters) {
      message
      response
    }
  }
`;

export const getBusinessAnalysisDutyItemsMutation = gql`
  mutation($filters: JSON!){
    getBusinessAnalysisDutyItems(filters: $filters) {
      message
      response
    }
  }
`;

export const markKeyHoldingInvoicedMutation = gql`
  mutation($items: JSON!){
    markKeyHoldingInvoiced(items: $items) {
      message
      response
    }
  }
`;

export const getSiaLicenseComplianceReportMutation = gql`
  mutation($filters: JSON!){
    getSiaLicenseComplianceReport(filters: $filters) {
      message
      response
    }
  }
`;

export const getDataQualityReportMutation = gql`
  mutation($filters: JSON!){
    getDataQualityReport(filters: $filters) {
      message
      response
    }
  }
`;